import Locales from 'UdeskLocales';
import { Popover } from 'udesk-ui';
import { PluginComponent } from 'react-markdown-editor-lite';
import AssociateSelect from 'src/components/common/associate-select';

export const CreateMdEditorCustomPlugin = (props) => {
    return class PropsSelect extends PluginComponent {
        // 这里定义插件名称，注意不能重复
        static pluginName = 'my-propsSelect';
        // 定义按钮被防止在哪个位置，默认为左侧，还可以放置在右侧（right）
        static align = 'left';

        constructor(props) {
            super(props);

            this.handleClick = this.handleClick.bind(this);
        }

        handleClick(pushConf, editorState, content) {
            // 调用API，往编辑器中插入内容
            this.editor.insertText(content);
        }

        render() {
            const locales = Locales['current'];

            return (
                <Popover
                    content={
                        <AssociateSelect
                            onClick={this.handleClick}
                            // pushConfContentChange={actions.pushConfContentChange}
                            pushConf={{}}
                            // associateDivRef={privates.associateDivRef}
                            // textAreaRef={privates.textAreaRef}
                            taskType={props.taskType}
                            taskTypeList={props.taskTypeList}
                            // taskId={props.taskId}
                        ></AssociateSelect>
                    }
                >
                    <span className="button button-type-counter" onClick={this.handleClick}>
                        {locales.fix.associatedData}
                    </span>
                </Popover>
            );
        }
    };
};
